export default {
  namespaced: true,
  intelbras: {
    title: "Intelbras",
    name: "Nome",
    panel_model: "Modelo do Painel",
    panel: "Painel",
    panels: "Paineis",
    host: "Host",
    port: "Porta",
    client_password: "Senha do Cliente",
    remote_control_password: "Senha de Controle Remoto",
    listening_port: "Porta de Escuta",
    facilities: "Instalações",
    event_code: "Código do Evento",
    alarm_type_sbo: "Tipo de Alarme (SBO)",
    description: "Descrição",
    zone: "Zona",
    num_conact_id: "Número da Conta de Contact ID",
    creation_date: "Data de Criação",
    date: "Data",
    masterAccounts: "contas mestres",
    masterAccount: "conta mestre",
    first_name: "primeiro nome",
    last_name: "sobrenome",
    link: "link",
    username: "nome de usuário",
    token: "token",
    password: "senha",
    token_expired: "expiração do token",
    email: "email",
    sites: "sites",
    site: "site",
    address: "endereço",
    latitude: "latitude",
    longitude: "longitude",
    timeZone: "fuso horário",
    file: "perfil",
    calendar: "calendário",
    serialNumber: "número de série",
    actions: "ações",
    schemaTypes: "tipos de esquemas",
    schema_type: "tipo de esquema",
    display_name: "nome de exibição",
    id: "id",
    devices: "dispositivos",
    gateway_id: "id do gateway",
    schema_actions: "ações do esquema",
    typeAlarm: "tipo de alarme",
    typeAlarms: "tipos de alarmes",
    priority: "prioridade",
    dispatchAlarm: "despacho de alarme",
    alarms: "alarmes",
    state: "estado",
    creation_time: "hora de criação",
    units: "instalações",
    center: "centro",
    sector: "setor",
    device: "dispositivo",
    schemaEvent: "evento",
    time: "hora",
    logs: "registros",
    channel: "canal",
    name_panel: "nome do painel",
    events: "eventos",
    syncCorrectly: "sincronizado corretamente",
    status: "Estado",
    instance_host: "Host da Instância",
    rules: "Regras",
    code: "Código",
    event: "Evento",
    event_id: "ID do evento",
    value: "Valor",
    zones_pgm: "Zona / PGM",
    pgm_output: "PGM / Saída",
    partition: "Partição",
    alias: "Alias",
    profile: "perfil",
    profiles: "profiles",
    syncDevices: "Sincronizar dispositivos",
    syncing: "Sincronizando",
    withoutProfile: "O painel não tem um perfil atribuído",
    reconnect: "Reconectar",
    rebuild: "Reiniciar",
    profile_name: "Nome do Perfil",
    type: "Tipo",
    active: "Activo",
    activate: "Ativar",
    deactivate: "Desativar",
    close: "Fechar",
    open: "Aberto",
    bypass: "Anular",
    enable: "Habilitar",
    panelOffline: "Panel is offline",
    panelStatusArmed: "Armado",
    panelStatusDisarmed: "Desarmado",
    panelStatusOffline: "Off-line",
    arm: "Armar",
    disarm: "Desarmar",
    arming: "Armando",
    disarming: "Desarmando",
    armedCorrectly: "Armado corretamente",
    disarmedCorrectly: "Desarmado corretamente",
    uuid: "UUID",
    connected: "Conectado",
    disconnected: "Desconectado",
  }
}
